import { useParams, Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getPublicDeal } from "../services/DealsService";
import PublicProductDetailPage from "./PublicProductDetailPage";

export default function DealRedirectPage() {
  const { dealId } = useParams<{ dealId: string }>();

  const { data: deal, isLoading, error } = useQuery({
    queryKey: ["deal", dealId],
    queryFn: () => getPublicDeal(dealId!),
    enabled: !!dealId,
    retry: false,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-primary-200 border-t-primary-600" />
      </div>
    );
  }

  if (deal) {
    // Free accounts get the share without retailer identifiers; online deals
    // still open in-app through the protected productKey.
    const productId = deal.upc || deal.productKey;
    if (!productId) return <PublicProductDetailPage />;
    const retailer = deal.retailer || "walmart";
    return <Navigate to={`/${retailer}/product/${encodeURIComponent(productId)}?storeId=${deal.storeId || "online"}`} replace />;
  }

  if (error || !deal) {
    return <Navigate to="/" replace />;
  }

  return null;
}
